import { FaArrowLeft } from "react-icons/fa";
import { Container, ContainerHeader, DadosContainer, Title } from "./style";
import { PrimaryButton } from "components/Button/style";
import { IResumoLote } from "../../../../interfaces/IResumoLote";
import { Col } from "react-bootstrap";

interface IProps {
  onClickVoltar: () => void;
  resumo: IResumoLote;
}
export function ResumoDetalhesLote({ onClickVoltar, resumo }: IProps) {
  return (
    <Container>
      <ContainerHeader>
        <Title>
          Lote {resumo.idLote} -{" "}
          {resumo.tipo === "bloquear" ? "Bloqueio" : "Desbloqueio"} de veículos
        </Title>

        <PrimaryButton
          buttonWidth="xl"
          buttonWidthTipo="px"
          onClick={onClickVoltar}
          outline
          variante="primary"
        >
          <FaArrowLeft />
          Voltar
        </PrimaryButton>
      </ContainerHeader>
      <DadosContainer>
        <Col>
          <div>Empresa</div>
          <div>
            <strong>{resumo.nomeEmpresa ?? "--"}</strong>
          </div>
        </Col>
        <Col>
          <div>Divisão</div>
          <div>
            <strong>{resumo.nomeDivisao ?? "--"}</strong>
          </div>
        </Col>
        <Col>
          <div>Centro de Custo</div>
          <div>
            <strong>{resumo.nomeCentroCusto ?? "--"}</strong>
          </div>
        </Col>
        <Col>
          <div>Solicitante</div>
          <div>
            <strong>{resumo.nomeSolicitante ?? "--"}</strong>
          </div>
        </Col>
        <Col>
          <div>CNPJ</div>
          <div>
            <strong>{resumo.cnpj ?? "--"}</strong>
          </div>
        </Col>
      </DadosContainer>
    </Container>
  );
}
